
(function(){
  // Menu: the old site's panel, opened by its toggle button; the icon swaps to an X like the original.
  var menu = document.querySelector('[data-sc-menu]');
  var toggle = document.querySelector('button[aria-label="Toggle menu"]');
  var nav = document.querySelector('.sc-root nav.fixed');
  if (menu && toggle) {
    if (nav) nav.appendChild(menu);
    var icon = toggle.querySelector('svg');
    var bars = icon ? icon.innerHTML : '';
    var cross = '<path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>';
    var setOpen = function(open){
      if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden','');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (icon) { icon.innerHTML = open ? cross : bars; icon.classList.toggle('lucide-x', open); icon.classList.toggle('lucide-menu', !open); }
    };
    toggle.setAttribute('aria-expanded','false');
    toggle.addEventListener('click', function(){ setOpen(menu.hasAttribute('hidden')); });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setOpen(false); }); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !menu.hasAttribute('hidden')) { setOpen(false); toggle.focus(); } });
    var here = location.pathname.replace(/\/$/,'');
    menu.querySelectorAll('[data-sc-link]').forEach(function(a){
      if (a.getAttribute('href') === here && here !== '/pages/the-field') { a.classList.remove('text-foreground','hover:text-primary'); a.classList.add('text-primary'); a.setAttribute('aria-current','page'); }
      if (here === '/pages/the-field' && a.getAttribute('href') === here) a.setAttribute('aria-current','page');
    });
  }
  // Nav after scrolling past 60px, as on the old site: cream glass bar, border, logo multiplied.
  if (nav && nav.classList.contains('bg-transparent')) {
    var logo = nav.querySelector('img.mix-blend-screen');
    var f = function(){
      var on = window.scrollY > 60;
      nav.classList.toggle('bg-transparent', !on);
      ['bg-background/95','backdrop-blur-md','border-b','border-border'].forEach(function(c){ nav.classList.toggle(c, on); });
      if (logo) { logo.classList.toggle('mix-blend-multiply', on); logo.classList.toggle('mix-blend-screen', !on); }
    };
    window.addEventListener('scroll', f, {passive:true}); f();
  }
  // Accordions: a button followed by a collapsed panel (height 0).
  document.querySelectorAll('.sc-root button').forEach(function(b){
    var panel = b.nextElementSibling;
    if (!panel || !/height:\s*0/.test(panel.getAttribute('style') || '')) return;
    b.setAttribute('aria-expanded','false');
    b.addEventListener('click', function(){
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.height = open ? 'auto' : '0px'; panel.style.opacity = open ? '1' : '0';
    });
  });
  // Carousels: stacked images with opacity classes plus dot buttons.
  document.querySelectorAll('.sc-root .relative').forEach(function(box){
    var imgs = Array.prototype.filter.call(box.children, function(c){ return c.tagName === 'IMG' && /opacity-(0|100)/.test(c.className); });
    if (imgs.length < 2) return;
    var dots = box.querySelectorAll('div.absolute button');
    var i = 0;
    function show(n){ i = (n + imgs.length) % imgs.length; imgs.forEach(function(im,k){ im.classList.toggle('opacity-100', k===i); im.classList.toggle('opacity-0', k!==i); }); dots.forEach(function(d,k){ var on = k===i; d.setAttribute('aria-current', on ? 'true':'false'); d.classList.toggle('bg-white', on); d.classList.toggle('scale-125', on); d.classList.toggle('bg-white/40', !on); }); }
    dots.forEach(function(d,k){ d.setAttribute('aria-label','Photo ' + (k+1)); d.addEventListener('click', function(){ show(k); }); });
    // no autoplay: the old site's galleries only move when a dot is clicked
  });
  // Audio player bar: the old site's player, rebuilt (play/pause at 0.95 speed, progress and seek, time, mute and volume).
  document.querySelectorAll('.sc-root audio').forEach(function(au){
    var bar = au.nextElementSibling;
    if (!bar || !/\bfixed\b/.test(bar.className) || !/\bbottom-0\b/.test(bar.className)) return;
    var track = bar.firstElementChild, fill = track && track.children[0], knob = track && track.children[1];
    var playBtn = bar.querySelector('button.rounded-full');
    var times = bar.querySelectorAll('.tabular-nums > span');
    var muteBtn = null, vol = bar.querySelector('input[type=range]');
    if (vol) muteBtn = vol.parentElement.querySelector('button');
    var svg = function(name, cls, inner){ return '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-' + name + ' ' + cls + '">' + inner + '</svg>'; };
    var PLAY = svg('play', 'w-3 h-3 sm:w-3.5 sm:h-3.5 ml-0.5', '<polygon points="6 3 20 12 6 21 6 3"></polygon>');
    var PAUSE = svg('pause', 'w-3 h-3 sm:w-3.5 sm:h-3.5', '<rect x="14" y="4" width="4" height="16" rx="1"></rect><rect x="6" y="4" width="4" height="16" rx="1"></rect>');
    var SPK = '<path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path>';
    var VOL = svg('volume2', 'w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4', SPK + '<path d="M16 9a5 5 0 0 1 0 6"></path><path d="M19.364 18.364a9 9 0 0 0 0-12.728"></path>');
    var MUTED = svg('volume-x', 'w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4', SPK + '<line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line>');
    var fmt = function(t){ if (!t || isNaN(t)) return '0:00'; var s = Math.floor(t % 60); return Math.floor(t / 60) + ':' + (s < 10 ? '0' : '') + s; };
    var level = 0.8, muted = false;
    au.volume = level;
    var paint = function(){
      var p = au.duration > 0 ? au.currentTime / au.duration * 100 : 0;
      if (fill) fill.style.width = p + '%';
      if (knob) knob.style.left = 'calc(' + p + '% - 5px)';
      if (times.length >= 3) { times[0].textContent = fmt(au.currentTime); times[2].textContent = fmt(au.duration); }
    };
    if (playBtn) {
      playBtn.setAttribute('aria-label', 'Play audio');
      playBtn.addEventListener('click', function(){
        if (au.paused) { au.playbackRate = 0.95; au.play().then(function(){ playBtn.innerHTML = PAUSE; playBtn.setAttribute('aria-label', 'Pause audio'); }).catch(function(){}); }
        else { au.pause(); playBtn.innerHTML = PLAY; playBtn.setAttribute('aria-label', 'Play audio'); }
      });
    }
    au.addEventListener('timeupdate', paint); au.addEventListener('durationchange', paint);
    au.addEventListener('ended', function(){ if (playBtn) { playBtn.innerHTML = PLAY; playBtn.setAttribute('aria-label', 'Play audio'); } });
    if (track) track.addEventListener('click', function(e){ if (!au.duration) return; var r = track.getBoundingClientRect(); au.currentTime = (e.clientX - r.left) / r.width * au.duration; paint(); });
    var showVol = function(){ if (muteBtn) { muteBtn.innerHTML = (muted || level === 0) ? MUTED : VOL; muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute'); } if (vol) vol.value = muted ? 0 : level; };
    if (vol) { vol.setAttribute('aria-label', 'Volume'); vol.addEventListener('input', function(){ level = parseFloat(vol.value); au.volume = level; au.muted = level === 0; muted = level === 0; showVol(); }); }
    if (muteBtn) muteBtn.addEventListener('click', function(){ muted = !muted; au.muted = muted; showVol(); });
    showVol();
  });
  // Field page: five movements as tabs (wide) or an accordion (phone).
  document.querySelectorAll('.sc-moves').forEach(function(box){
    var items = Array.prototype.slice.call(box.children);
    if (items.length < 2) return;
    var wide = window.matchMedia('(min-width: 768px)');
    var bar = document.createElement('div'); bar.className = 'sc-mv-tabs'; bar.setAttribute('role', 'tablist');
    var tabs = [];
    function show(n){
      items.forEach(function(it,k){ it.classList.toggle('on', k===n); if (it._row) it._row.setAttribute('aria-expanded', k===n ? 'true' : 'false'); });
      tabs.forEach(function(t,k){ t.setAttribute('aria-selected', k===n ? 'true' : 'false'); t.tabIndex = k===n ? 0 : -1; });
    }
    items.forEach(function(it,k){
      var row = it.querySelector('.flex'); var head = row && row.children[0]; var text = row && row.children[1];
      if (!head || !text) return;
      it.classList.add('sc-mv-item'); it.id = it.id || ('sc-mv-' + k); it._row = row;
      row.classList.add('sc-mv-row'); head.classList.add('sc-mv-head'); text.classList.add('sc-mv-text');
      row.tabIndex = 0; row.setAttribute('role', 'button');
      function flip(){ if (wide.matches) return; var open = !it.classList.contains('on'); it.classList.toggle('on', open); row.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      row.addEventListener('click', flip);
      row.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
      var t = document.createElement('button'); t.type = 'button'; t.setAttribute('role', 'tab'); t.setAttribute('aria-controls', it.id);
      var num = document.createElement('span'); num.textContent = head.children[0] ? head.children[0].textContent : String(k + 1);
      t.appendChild(num); t.appendChild(document.createTextNode(head.children[1] ? head.children[1].textContent : ''));
      t.addEventListener('click', function(){ show(k); });
      t.addEventListener('keydown', function(e){ var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); var n = (k + d + tabs.length) % tabs.length; show(n); tabs[n].focus(); });
      tabs.push(t); bar.appendChild(t);
    });
    if (tabs.length !== items.length) return;
    box.insertBefore(bar, box.firstChild); box.classList.add('sc-js'); show(0);
  });
  // The visitor may share feedback anonymously. Shopify's contact endpoint still expects a valid
  // sender address, so the store email is the fallback and a supplied visitor email replaces it.
  var feedback = document.getElementById('sc-visitor-feedback');
  if (feedback) feedback.addEventListener('submit', function(){
    var supplied = feedback.querySelector('[data-sc-visitor-email]');
    var sender = feedback.querySelector('[data-sc-contact-email]');
    if (supplied && sender && supplied.value.trim()) sender.value = supplied.value.trim();
    var b = feedback.querySelector('button[type="submit"]'); if (b) { b.disabled = true; b.textContent = 'Sharing…'; }
  });
  var ebook = document.getElementById('sc-ebook-request');
  if (ebook) ebook.addEventListener('submit', function(){ var b = ebook.querySelector('button[type="submit"]'); if (b) { b.disabled = true; b.textContent = 'Requesting…'; } });
  // Request a Visit (Joda, Oct 29: "take down the calendar"): the offering cards stay as a choice of interest; no date or time.
  var book = document.getElementById('sc-book');
  if (book) {
    var selOffer = null;
    var offerField = book.querySelector('input[name="contact[Offering]"]');
    var submit = book.querySelector('[data-sc-submit]'), err = book.querySelector('[data-sc-err]');
    var cards = book.querySelectorAll('[data-sc-offer]');
    cards.forEach(function(c){ c.addEventListener('click', function(){
      selOffer = (selOffer === c.getAttribute('data-sc-offer')) ? null : c.getAttribute('data-sc-offer');
      cards.forEach(function(o){ var on = selOffer && o === c; o.className = 'text-left border p-4 sm:p-5 transition-colors ' + (on ? 'border-primary bg-primary/10' : 'border-border bg-background hover:border-primary/50'); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (offerField) offerField.value = selOffer || '';
    }); });
    book.addEventListener('submit', function(e){
      var n = book.querySelector('[name="contact[name]"]'), m = book.querySelector('[name="contact[email]"]');
      if (!n.value.trim() || !m.value.trim()) { e.preventDefault(); if (err) { err.textContent = 'Please enter your name and email.'; err.hidden = false; } return; }
      if (submit) submit.textContent = 'Sending…';
    });
  }
  // Request an Invitation: keep the first name for the old site's thank-you line.
  var inv = document.getElementById('sc-invitation');
  if (inv) inv.addEventListener('submit', function(){
    var n = inv.querySelector('[name="contact[name]"]'); try { sessionStorage.setItem('sc-first', (n.value || '').trim().split(' ')[0]); } catch (x) {}
    var b = inv.querySelector('button[type="submit"]'); if (b) b.textContent = 'Sending…';
  });
  var first = document.querySelector('[data-sc-first]');
  if (first) { try { var f = sessionStorage.getItem('sc-first'); if (f) { first.textContent = ', ' + f; sessionStorage.removeItem('sc-first'); } } catch (x) {} }
  // Home: "RSVP for November 1st" goes to the contact form, as on the old site.
  document.querySelectorAll('.sc-root button').forEach(function(b){
    if (!/RSVP for November/i.test(b.textContent)) return;
    b.addEventListener('click', function(){
      var t = document.getElementById('connect') || document.getElementById('sc-home-contact');
      if (!t) return;
      t.scrollIntoView({behavior: 'smooth'});
      var n = document.getElementById('sc-hc-name'); if (n) setTimeout(function(){ n.focus({preventScroll: true}); }, 700);
    });
  });
  // 404: name the missing address, as the old site did (Shopify reports the path as /404 here).
  var miss = document.querySelector('[data-sc-404]');
  if (miss) { try { miss.textContent = '"' + decodeURIComponent(location.pathname.replace(/^\/+|\/+$/g, '')) + '"'; } catch (x) {} }
})();
